export default {
    title: "发货确认",
    header: "@:views.survey.delivery.title",
    result: {
        header: "谢谢",
        message: "感谢您的回复。"
    },
    status: {
        yes: "请核对下方已勾选的商品以确认已送达，并取消勾选尚未收到的商品。然后点击“提交”进行确认。",
        no: "请确认您未收到以下任何商品。如果您收到了其中任何商品，请勾选“已收到商品”旁边的复选框，然后点击“提交”进行确认。"
    },
    model: {
        checked: {
            label: "已收到"
        }
    },
    button: {
        submit: {
            cta: "提交",
            processing: "提交"
        }
    }
}